'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-show.routes';

export class PropertyShowComponent {
  constructor($stateParams, PropertyService, ServiceRequestTicketsService, WorkOrderTicketsService, ViolationTicketsService,
              TaskService, $uibModal, $window, RecentVisits, PinnedItems, $state, CustomEntityService, SettingsService,
              ContactService, CommunityService, QuickbooksImportService, EFormResultsService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.propertyId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$state = $state;

    this.tasks = [];
    this.activities = [];
    this.issues = [];
    this.custom = {};

    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.ContactService = ContactService;
    this.CommunityService = CommunityService;
    this.SettingsService = SettingsService;

    this.QuickbooksImportService = QuickbooksImportService;
    this.EFormResultsService = EFormResultsService;

    this.contactTypesMap = {};
    this.contactTypes = [];

    this.ownerDropdownMenu = [{
      title: 'Add Primary Owner',
      action: _ => {
        this.openAddContactModal('primary-owner');
      }
    },{
      title: 'Add Owner',
      action: _ => {
        this.openAddContactModal('owner');
      }
    },{
      title: 'Add Renter',
      action: _ => {
        this.openAddContactModal('renter');
      }
    },{
      title: 'Add Previous Owner',
      action: _ => {
        this.openAddContactModal('previous-owner');
      }
    },{
      title: 'Change Contacts and Dates',
      action: _ => {
        this.openEditContactsModal()
      }
    }];

    this.count = {
      workOrders: 0,
      violations: 0,
      serviceRequests: 0,
      tasks: 0
    };

    this.PropertyService = PropertyService;
    this.refreshData();

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.contactTypesMap = appSettings.data.contactTypesMap;
      this.contactTypes = Object.keys(this.contactTypesMap);

      if (this.contactTypes) {
        this.ownerDropdownMenu = [];
        this.contactTypes.forEach(type => {
          this.ownerDropdownMenu.push({
            title: 'Add ' + this.contactTypesMap[type],
            action: _ => {
              this.openAddContactModal(type);
            }
          })
        });
        this.ownerDropdownMenu.push({
          title: 'Change Contacts and Dates',
          action: _ => {
            this.openEditContactsModal()
          }
        });
      }
    });

    EFormResultsService.queryBySuiteConnectionProperty({propertyId: this.propertyId}, eforms => {
      this.eforms = eforms;
    })

    TaskService.getByContext({id: this.propertyId}, data => {
      let filteredData = data.filter(task => task.status == 'open');
      this.count.tasks = filteredData.length;
    });

    ServiceRequestTicketsService.getByProperty({id: this.propertyId}, data => {
      let filteredData = data.filter(sr => sr.status == 'open');
      this.count.serviceRequests = filteredData.length;
      this.issues = this.issues.concat(filteredData.map(sr => {
        return {
          type: 'Service Request',
          name: sr.code + ": " + sr.name,
          date: sr.meta.creationDate,
          url: "/servicerequest/ticket/detail/"+sr._id
        }
      }));
    });

    WorkOrderTicketsService.getByProperty({id: this.propertyId}, data => {
      let filteredData = data.filter(wo => wo.status == 'open');
      this.count.workOrders = filteredData.length;
      this.issues = this.issues.concat(filteredData.map(wo => {
        return {
          type: 'Work Order',
          name: wo.code + ": " + wo.name,
          date: wo.meta.creationDate,
          url: "/workorder/ticket/detail/"+wo._id
        }
      }));
    });

    ViolationTicketsService.getByProperty({id: this.propertyId}, data => {
      let filteredData = data.filter(ccr => ccr.status == 'open');
      this.count.violations = filteredData.length;
      this.issues = this.issues.concat(filteredData.map(ccr => {
        return {
          type: 'Violation',
          name: ccr.code + ": " + ccr.name,
          date: ccr.meta.creationDate,
          url: "/violation/ticket/detail/"+ccr._id
        }
      }));
    });

    SettingsService.getByName({name: 'custom-fields-views'}, settings => {
      this.customFieldsConfig = settings.data.property || {};
    });

    SettingsService.getByName({name: 'custom-entities-views'}, settings => {
      this.customEntitiesConfig = settings.data.property || {display:[]};
      this.customEntitiesConfig.display.forEach(customType => {
        let typeConfig = this.customEntitiesConfig[customType];
        this.custom[customType] = CustomEntityService.getCustomList({type: customType, refField: typeConfig.refField, refId: $stateParams.id});

        /*this.trailerStorages = CustomEntityService.getCustomList({type: 'trailer-storage', refField: 'propertyId', refId: $stateParams.id});
        this.vehicles = CustomEntityService.getCustomList({type: 'vehicle', refField: 'propertyId', refId: $stateParams.id});
        this.pets = CustomEntityService.getCustomList({type: 'pet', refField: 'propertyId', refId: $stateParams.id});*/

      });

    });

  }

  openEFormResultModal(eFormId, eFormResultId) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormResultModal',
      resolve: {
        config: function(){
          return {
            eFormId: eFormId,
            eFormResultId: eFormResultId
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.firstName)
      composedName += contact.firstName;

    if (contact.middleName)
      composedName += " " + contact.middleName;

    if (contact.lastName)
      composedName += " " + contact.lastName;

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += ", " + contact.company;

    }

    return composedName;
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  openStripePaymentsModal() {

    this.CommunityService.get({id: this.property.community._id}, community => {

      if (!community.stripe || !community.stripe.enabled || !community.stripe.connectedAccountId) {
        alert('no stripe enabled or connected id available');
        return;
      }

      let connectedAccountId = community.stripe.connectedAccountId;

      let primary = this.property.contacts.find(contact => contact.type == 'primary-owner');

      if (!primary || primary == "-") {
        alert('no primary owner');
        return;
      }

      this.ContactService.get({id: primary.contact._id}, contact => {

        let email = this.getPrimaryEmail(contact);

        if (!email || email == "-") {
          alert('no primary email on primary owner');
          return;
        }

        let name = contact.firstName + " " + contact.lastName;

        var that = this;

        var modalInstance = this.$uibModal.open({
          animation: true,
          component: 'connectedAccountCharges',
          resolve: {
            config: function() {
              return {
                accountId: connectedAccountId,
                name: name,
                title: "Payments " + name + " (" + community.name + ")",
                contactEmail: email
              }
            }
          },
          size: 'lg'
        });

        modalInstance.result.then(
          function () { /* ok */ },
          function () { /* cancel */ }
        );


      });
    });

  }

  getSectionTemplate(section) {
    if (!this.customFieldsConfig.sectionTemplate || !this.customFieldsConfig.sectionTemplate[section])
      return null;

    return this.customFieldsConfig.sectionTemplate[section];
  }

  getSectionEditAction(section) {
    if (!this.customFieldsConfig.editAction || !this.customFieldsConfig.editAction[section])
      return null;

    return this.customFieldsConfig.editAction[section];
  }

  editSection(section) {
    let fields = this.getSectionEditAction(section).split(',').map(field => field.trim());

    var that = this;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("property")) {
        let customSchema = customFieldSettings.data.property;

        let sectionSchema = {
          type: "object",
          properties: {}
        };

        fields.forEach(field => {
          sectionSchema.properties[field] = angular.copy(customSchema.properties[field]);
        });

        const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
        const REGEX_FIRST = /([^\W_]+[^\s-]*)/;
        const capitalize = (input, all) => {
          if (!input) return '';
          const regex = (all) ? REGEX_ALL : REGEX_FIRST;
          return input.replace(regex, (txt) =>
            txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        };

        var modalInstance = this.$uibModal.open({
          animation: true,
          component: 'schemaFormModal',
          resolve: {
            config: function() {
              return {
                title: capitalize(section, true),
                icon: "pencil-square-o",
                model: (that.property.customFields) ? angular.copy(that.property.customFields) : {},
                schema: sectionSchema
              }
            }
          },
          size: 'md'
        });

        modalInstance.result.then(
          function (editedCustomFields) {

            that.property.customFields = editedCustomFields;

            that.PropertyService.update({id: that.propertyId}, that.property, _ => {
              that.refreshData();
            }, err => {
              console.log('could not edit contacts of property');
            });

          },
          function () { }
        );

      }
    });





  }

  refreshData() {
    if (this.propertyId) {
      this.PropertyService.get({id: this.propertyId}, data => {
        this.property = data;

        if (this.property.customFields && this.property.customFields.quickbooksName) {
          this.QuickbooksImportService.getBalance({propertyId: this.property._id}, data => {
            this.balances = data;
          });
        }

        this.CommunityService.get({id: this.property.community._id}, cmty => {
          this.eVotingEnabled = cmty.eVoting && cmty.eVoting.enabled;

          if (this.eVotingEnabled && this.property.eVoting && this.property.eVoting.voter) {
            this.ContactService.get({id: this.property.eVoting.voter}, contact =>{
              this.voter = contact;
            });
          }
        });

        this.RecentVisits.addPortfolio(this.propertyId, "property", `${this.property.address.street}, ${this.property.address.city} ${this.property.address.state}, ${this.property.address.zip} / ${this.property.lotNo}`);
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.propertyId);
      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  editVoting() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'schemaFormModal',
      resolve: {
        config: function() {
          return {
            title: "Voting",
            icon: "pencil-square-o",
            model: (that.property.eVoting) ? angular.copy(that.property.eVoting) : {},
            schema: {
              type: "object",
              properties: {
                voter: {
                  "title": "Voter",
                  "type": "string",
                  "x-schema-form": {
                    "type": "entitylookup",
                    "lookuptype": "contact"
                  }
                },
                blocked: {
                  type: "boolean",
                  title: "Blocked",
                  description: "The voter is not allowed to cast a vote for this property currently"
                },
                votingCertificate: {
                  type: "string",
                  title: "Voting Certificate",
                  "x-schema-form": {
                    type: "single-file-upload"
                  }
                }
              },
              required: []
            }
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (editedEVoting) {
        that.property.eVoting = editedEVoting;

        that.PropertyService.update({id: that.propertyId}, that.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );
  }

  openCustomEntityLetterWithContactSelect(entityId, entityName, template) {
    var that = this;

    let MAP_GROUP = {'primary-owner': "Primary Owner", 'owner': "Owner", 'renter': 'Renter', 'previous-owner': "Previous Owner", "vistor": "Visitor"};

    this.PropertyService.getContacts({id: this.propertyId}, contacts => {

      let pickContactPreselects = [];

      contacts.forEach(oContact => {

        let group = MAP_GROUP[oContact.type];
        let name = oContact.contact.firstName + " " + oContact.contact.lastName;
        let phone = "";
        let email = "";

        if (oContact.phone && oContact.phone.length) {
          let primaryPhone = oContact.phone.find(p => p.isPrimary);
          if (primaryPhone) {
            phone = primaryPhone.number;
          }
        }

        if (oContact.email && oContact.email.length) {
          let primaryEmail = oContact.email.find(e => e.isPrimary);
          if (primaryEmail) {
            email = primaryEmail.address;
          }
        }

        oContact.contact.address.forEach(addr => {

          let composedName = name + ", " + addr.street + " (" + addr.type + ")";
          if (addr.isPrimary)
            composedName += " (PRIMARY)";

          pickContactPreselects.push({
            name: composedName,
            group: group,
            payload: {
              name: name,
              address: addr.street,
              address2: addr.street2,
              phone: phone,
              email: email
            }
          });

        })

      });

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'reportFilterModal',
        resolve: {
          config: function() {
            return {
              filter: [{type: "pick-contact-preselect"}],
              pickContactPreselects: pickContactPreselects,
              title: "Create and Download Letter",
              report: 'custom-entity-letter',
              entityId: entityId,
              entityName: entityName,
              template: template,
              fileTypes: ['docx','odt','pdf'],

            }
          }
        },
        size: 'md'
      });

      modalInstance.result.then(
        function () {},
        function () { /* cancel */ }
      );
    });
  }

  openEditContactsModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'editPropertyContacts',
      size: 'lg',
      resolve: {
        config: function() {
          return {
            contacts: that.property.contacts,
            contactTypes: that.contactTypes.length ? that.contactTypesMap : null
          }
        }
      }
    });

    modalInstance.result.then(newContacts => {

        that.property.contacts = newContacts;

        that.PropertyService.update({id: that.propertyId}, this.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );

  }

  getAddress(property) {
    try {
      return `${property.address.street}, ${property.address.city}, ${property.address.state} ${property.address.zip}`;
    } catch (e){
      return "-";
    }
  }

  openAddContactModal(type) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addPropertyContact',
      size: 'lg',
      resolve: {
        config: function() {
          return {
            type: type,
            contactTypes: that.contactTypes.length ? that.contactTypesMap : null
          }
        }
      }
    });

    modalInstance.result.then(newContact => {

        that.property.contacts.push(newContact);

        that.PropertyService.update({id: that.propertyId}, this.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add contact to property');
        });
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.PropertyService.addAttachments({id: that.propertyId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to property');
        });
      },
      function () { /* cancel */ }
    );

  }

  createWorkOrder() {
    this.$state.go('workorder-ticket-edit',{propertyId: this.propertyId});
  }

  createViolation() {
    this.$state.go('violations-ticket-edit',{propertyId: this.propertyId});
  }

  getContactType(contact) {
    // If custom types defined
    if (this.contactTypesMap && this.contactTypes.includes(contact.type))
      return this.contactTypesMap[contact.type];

    // Default
    return contact.type.split("-").join(" ");
  }
}

export default angular.module('conduu.propertyShow', [uiRouter])
  .config(routes)
  .component('propertyShow', {
    template: require('./property-show.html'),
    controller: PropertyShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-show/property-show.component.js